import { render, staticRenderFns } from "./TestVue.vue?vue&type=template&id=3cf5987c&scoped=true&"
import script from "./TestVue.vue?vue&type=script&lang=js&"
export * from "./TestVue.vue?vue&type=script&lang=js&"
import style0 from "./TestVue.vue?vue&type=style&index=0&id=3cf5987c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf5987c",
  null
  
)

export default component.exports